export default {
  beforeRouteEnter: (from, to, next) => {
    next('/Login');
  },
};
